import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import ReactTooltip from 'react-tooltip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import _flatten from 'lodash/flatten';
import _differenceBy from 'lodash/differenceBy';

import SubmittedPresentationTable from 'components/PresentationTable/SubmittedPresentationTable';
import OrphanedPresentationTable from 'components/PresentationTable/OrphanedPresentationTable';

import CreateNewUserModalButton from 'components/Modals/CreateNewUserModalButton';

import Table from 'react-bootstrap/Table';
import {
  owner_perms,
  apiUrl,
  org_friendly_url,
  //locationSearchAPI,
  user_entity_uuid,
  user_access_level,
  searchUrl,
  //presentation_Creation_API,
  //user_API,
  myHeaders_Auth_With_Cache_Control,
  myHeaders_Autorized,
  events_list_api,
  //HeaderConfig
} from 'Api/Api';
import {
  get_current_unix_stamp,
  //dateConvert,
  //unixDateConversion,
  get_link_base_url
} from 'utils/Helper';
import axios from 'axios';
//import CreatePresenter from 'components/CreatePresenter/CreatePresenter';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
// import EventSelect from 'components/MultiSelectSearch/EventSelect';
import './style.css';
//import avatar from 'Assets/avatarnew.svg';
import { withAsync, Typeahead } from 'react-bootstrap-typeahead';
import { local_routes } from 'utils/Routes';
//import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import UserContext from 'store/UserContext';
//import { get_user_info } from '../../../../Api/GetUserInfo';
import PresentationPresenterCombo from '../../../../components/PresentationTable/PresentationPresenterCombo';
import { Modal } from 'react-bootstrap';
const AsyncTypeahead = withAsync(Typeahead);

//let tempArr = []; // this is actually all of the cities

function Presenters(props) {
  //const context = UserContext;
  const context = useContext(UserContext);

  //const [event_presentations_array, setEventPresentationsArray] = useState([]); // JBB 8/2/2021 - raw array of presentations associated w/event, including presenter users xref data
  const [event_presenters_array, setEventPresentersArray] = useState([]);
  const [submitted_presentations_array, setSubmittedPresentationsArray] = useState([]);
  const [orphaned_presentations_array, setOrphanedPresentationsArray] = useState([]); // for event presentations w/o a matching event presenter
  const [source_owner_flag, setSourceOwnerFlag] = useState(false);
  const [addingPerson, setAddingPerson] = useState(false);
  const [options, setOptions] = useState([]); // for add presenter typeahead search
  const [isAddPresenters, setIsAddPresenters] = useState(false); // for add presenter typeahead search
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false); // for add presenter modal

  //const [source_owner, set_source_owner] = useState(false);
  //const [firstname, setFirstname] = useState('');
  //const [lastname, setLastname] = useState('');
  //const [userOwnedPresentations, setUserOwnedPresentations] = useState([]);
  
  // const [presenters_typeahead, set_presenters_typeahead] = useState([]); // stores matches for onAddPresentersChange
  // const [selectedPresentation, setSelectedPresentation] = useState([]);
  
  //const [showComponent, setShowComponent] = useState(false);
  
  /*
  const [presentersArr, setPresentersArr] = useState([]);
  const [presenterArrAddToPk, setPresenterArrAddToPk] = useState([]);
  const [avatar_image_url, set_avatar_image_url] = useState();
  
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const [imgLoader, setImgLoader] = useState(false);
  const [cityArr, setCityArr] = useState([]);
  const [city_Data, set_city_Data] = useState();
  const [city, setCity] = useState('');
  const [firstCity, setFirstCity] = useState();
  const [userLocationData, setUserLocationData] = useState();
  const [countryArr, setCountryArr] = useState([]);
  const [country, setCountry] = useState('');
  const [userPresentations, setUserPresentations] = useState([]);
  const [submitted_presentations, set_submitted_presentations] = useState([]);
  // const [closeComponent, setCloseComponent] = useState(true);
  
  const [publishData, setPublishData] = useState([]);
  const [addPresentationList, setAddPresentationList] = useState([]);
  const [selectedPresenters, setSelectedPresenters] = useState({});

  const [nextBtnLoader, setNextBtnLoader] = useState(false);
  const [createVenueLoader, setCreateVenueLoader] = useState(false);
  const [createPresenterLoader, setCreatePresenterLoader] = useState(false);
  const [userCollisionError, setUserCollisionError] = useState();
  const [locationData, setLocationData] = useState();
  const [file, setFile] = useState();
  const [successFormData, setSuccessFormData] = useState(0);
  const [currentUserFirstName, setCurrentUserFirstName] = useState('');
  const [currentUserLastName, setCurrentUserLastName] = useState('');
  // const [dataArray, setDataArray] = useState();
  */
  
  
  // let changesPresenterKey = '';
  // let onClickToggleAddUser = onClickToggleAddUser();
  // let countryCityFilter = countryCityFilter();
  // let onClickFromRmUser = onClickFromRmUser();

  let presenter_typeahead_ref = React.createRef();

  let workspace_base_url = '';
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + '/' + org_friendly_url;
  }

  // Button click Show Component
  //const onClickToggleAddUser = () => {
    //setShowComponent(!showComponent);
    //setShow(false);
  //};
  
  // const onClickFromRmUser = () => {
  //   setCloseComponent(!closeComponent);
  // };

  async function getEventPresenterData() {
    console.log("getEventPresenterData");
    if (!props.event_uuid) {
      console.error('BAD! No event_uuid');
      return;
    }
    
    let get_presentations_params = {
      limit: 1000,
      filter_obj: {
        order_integer: {
          gte: 1
        }
      },
      do_recursive: true // will also get user info per presentation
    };
    let get_submitted_presentations_params = {
      limit: 1000,
      filter_obj: {
        submitted_time: {
          gte: 1
        },
        rejected_time: {
          exists: false
        },
        order_integer: {
          exists: false
        }
      },
      do_recursive: true // will also get user info per presentation
    };
    let get_presenters_params = {
      limit: 1000,
      sort_obj: {
        presenter_order_integer: 'asc'
      },
      filter_obj: {
        presenter_integer: {
          gte: 1
        }
      }
    };
    
    let [event_presentations_response,event_submitted_presentations_response,event_presenters_response] = await Promise.all([
      axios.get(`${events_list_api}/${props.event_uuid}/presentations`, { params: get_presentations_params, ...myHeaders_Auth_With_Cache_Control }),
      axios.get(`${events_list_api}/${props.event_uuid}/presentations`, { params: get_submitted_presentations_params, ...myHeaders_Auth_With_Cache_Control }),
      axios.get(`${events_list_api}/${props.event_uuid}/users`, { params: get_presenters_params, ...myHeaders_Auth_With_Cache_Control })
    ]);

    //let event_presentations_array = event_presentations_response.data.filter((item) => item.xref_data && item.xref_data.order_integer);
    //setEventPresentationsArray(event_presentations_array);
    //setEventPresentationsArray(event_presentations_response.data);

    let submitted_presentations_array = event_submitted_presentations_response.data;
    
    //let submitted_presentations_array = event_presentations_response.data.filter((item) => (item.xref_data && item.xref_data.submitted_time && !item.xref_data.rejected_time));
    // mutate submitted_presentations_array to get presenter_info
    submitted_presentations_array = submitted_presentations_array.map((item) => {
      if (item.users) {
        let presenter_index = item.users.findIndex((item2) => (item2.xref_data && item2.xref_data.presenter_integer === 1));
        if (presenter_index >= 0) {
          item.presenter_info = item.users[presenter_index];
        }
      }
      return item;
    });
    setSubmittedPresentationsArray(submitted_presentations_array);

    // attach an event presentation to each user in event_presenters array
    let event_presenters_array = event_presenters_response.data;
    event_presenters_array.forEach((event_user_obj) => {
      let user_event_presentation = event_presentations_response.data.filter(
        (event_presentation_obj) =>
          event_presentation_obj.users &&
          event_presentation_obj.users.some(
            (presentation_user_obj) => presentation_user_obj.entity_uuid === event_user_obj.entity_uuid
          )
      ).shift();
      
      if (user_event_presentation) {
        if (!user_event_presentation.xref_data || !('visibility_integer' in user_event_presentation.xref_data)) {
          user_event_presentation.visibility_integer = 1;
        } else {
          user_event_presentation.visibility_integer = user_event_presentation.xref_data.visibility_integer;
        }
  
        if (user_access_level === 'admin' || user_event_presentation.shared_access_write_uuids.includes(user_entity_uuid)) {
          user_event_presentation.editable = true;
        }
      }
      
      event_user_obj.presentation_info = user_event_presentation;
    });
    
    //let event_presenters_array = event_presenters_response.data.filter((item) => item.xref_data && item.xref_data.presenter_integer);

    setEventPresentersArray(event_presenters_response.data);
    
    // determine if current user is also an owner of the source (location or channel)
    if (props.source_info.entity_type === 'locations') {
      if (
        owner_perms &&
        owner_perms['locations'] &&
        owner_perms['locations'][props.source_info.entity_uuid] &&
        owner_perms['locations'][props.source_info.entity_uuid] === 'admin'
      ) {
        setSourceOwnerFlag(true);
      }
    } else if (props.source_info.entity_type === 'channels') {
      if (
        owner_perms &&
        owner_perms['channels'] &&
        owner_perms['channels'][props.source_info.entity_uuid] &&
        owner_perms['channels'][props.source_info.entity_uuid] === 'admin'
      ) {
        setSourceOwnerFlag(true);
      }
    }
    
    // we also need to get presentations associated with the event that do not have presenters associated with the event.
    let orphaned_presentations_array = [];
    event_presentations_response.data.forEach((tmp_presentation_obj) => {
      if (tmp_presentation_obj.users) {
        let presenter_found_flag = tmp_presentation_obj.users.some((tmp_user_obj) => {
          if (tmp_user_obj.xref_data && tmp_user_obj.xref_data.presenter_integer === 1) {
            tmp_presentation_obj.presenter_info = tmp_user_obj;
            if (event_presenters_response.data.some((tmp_user_obj2) => tmp_user_obj2.entity_uuid === tmp_user_obj.entity_uuid)) {
              return true;
            }
          }
        });
        if (!presenter_found_flag) {
          orphaned_presentations_array.push(tmp_presentation_obj);
        }
      }
    });
    setOrphanedPresentationsArray(orphaned_presentations_array);
    //console.log("ORPHANED PRESENTATIONS",orphaned_presentations_array);
    
  }

  useEffect(() => {
    (async () => {
      await getEventPresenterData();
      setLoading(false);
    })();
  }, []);

/*
  useEffect(() => {
    (async () => {
      if (!props.event_uuid) {
        console.error('BAD! No event_uuid');
        return;
      }
      //this here gets the current user's first and last name for the email function on line 997
      let getUserFirstName = await get_user_info();
      let getUserLastName = await get_user_info();
      setCurrentUserFirstName(getUserFirstName.firstname);
      setCurrentUserLastName(getUserLastName.lastname);

      if (props.source_info.entity_type === 'locations') {
        if (
          owner_perms &&
          owner_perms['locations'] &&
          owner_perms['locations'][props.source_info.entity_uuid] &&
          owner_perms['locations'][props.source_info.entity_uuid] === 'admin'
        ) {
          set_source_owner(true);
        }
      } else if (props.source_info.entity_type === 'channels') {
        if (
          owner_perms &&
          owner_perms['channels'] &&
          owner_perms['channels'][props.source_info.entity_uuid] &&
          owner_perms['channels'][props.source_info.entity_uuid] === 'admin'
        ) {
          set_source_owner(true);
        }
      }
      let tmp_bypass_workspace_api_headers = { ...HeaderConfig.headers };
      tmp_bypass_workspace_api_headers['X-PK-Organization'] = '';

      let user_presentations_filter_obj = {
        status_code: {
          eq: 1
        },
        entity_owner_integer: {
          gte: 1
        }
      };
      if (
        props.event_info.event_presentation_format &&
        props.event_info.event_presentation_format !== 'any'
      ) {
        let [slide_count, slide_length] =
          props.event_info.event_presentation_format.split('x');
        user_presentations_filter_obj.slide_count = { eq: slide_count };
        user_presentations_filter_obj.slide_length = { eq: slide_length };
      }

      let [
        pkDataRes, // current presentations for event - JBB 8/2/2021 - will also get presenter data for those presentations
        userDataApi, // current user data
        locationCityRes, // list of all cities - JBB 8/2/2021 - I think we use this in the "create new user" functionality
        locationDataRes, // what is user's home city - JBB 8/2/2021 - I think we use this in the "create new user" functionality
        presentationDataRes // current user's presentations - JBB 8/2/2021 - I think we will not need this anymore
      ] = await Promise.all([
        axios.get(
          `${events_list_api}/${props.event_uuid}/presentations?limit=1000&do_recursive=true`,
          myHeaders_Auth_With_Cache_Control
        ),
        axios.get(
          `${user_API}/${user_entity_uuid}`,
          myHeaders_Auth_With_Cache_Control
        ),
        axios.get(
          `${locationSearchAPI}?coordinates_lat=0&coordinates_lon=0&radius=20038`,
          { headers: tmp_bypass_workspace_api_headers }
        ),
        axios.get(
          `${user_API}/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent(
            '{"resident_integer":{"gte":1}}'
          )}`,
          myHeaders_Auth_With_Cache_Control
        ),
        //axios.get(`${user_API}/${user_entity_uuid}/presentations?sort_obj=${encodeURIComponent('{"created_time":"asc"}')}&filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"entity_owner_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
        axios.get(
          `${user_API}/${user_entity_uuid}/presentations?sort_obj=${encodeURIComponent(
            '{"created_time":"asc"}'
          )}&filter_obj=${encodeURIComponent(
            JSON.stringify(user_presentations_filter_obj)
          )}`,
          myHeaders_Auth_With_Cache_Control
        )
      ]);

      // JBB 8/2/2021 - set raw event presentations array to pass to Combo component
      setEventPresentationsArray(pkDataRes.data);

      // get presenters for the event
      let presenter_presentations_array = [];
      let userDataRes = {
        data: props.event_info.users.filter(
          (item) => item.xref_data && item.xref_data.presenter_integer
        )
      };

      if (userDataRes.data) {
        let response = userDataRes.data;
        console.log('******RESPONSE*****', response);
        let data = response.map((data) => {
          return {
            presenter_name: `${data.firstname} ${data.lastname}`,
            presenter_friendly_url: data.friendly_url,
            entity_uuid: data.entity_uuid,
            avatar_image_url: data.avatar_image_url
              ? data.avatar_image_url
              : null
          };
        });
        let addPresenterToPk = response.map((data) => {
          return {
            label: `${data.firstname} ${data.lastname}`,
            value: data.entity_uuid
          };
        });
        // now get presentations for each presenter in event, to make "Add Presentation" dropdown
        let user_presentations_filter_obj = {
          status_code: {
            eq: 1
          },
          presenter_integer: {
            gte: 1
          }
        };
        if (
          props.event_info.event_presentation_format &&
          props.event_info.event_presentation_format !== 'any'
        ) {
          let [slide_count, slide_length] =
            props.event_info.event_presentation_format.split('x');
          user_presentations_filter_obj.slide_count = { eq: slide_count };
          user_presentations_filter_obj.slide_length = { eq: slide_length };
        }
        const get_presenter_presentations_promises = data.map(
          ({ entity_uuid }) =>
            //LCK USE THIS API CALL
            axios.get(
              `${user_API}/${entity_uuid}/presentations?sort_obj=${encodeURIComponent(
                '{"created_time":"desc"}'
              )}&filter_obj=${encodeURIComponent(
                JSON.stringify(user_presentations_filter_obj)
              )}&limit=1000`,
              myHeaders_Auth_With_Cache_Control
            )
        );
        let resArr = await Promise.all(get_presenter_presentations_promises);

        const dataArr = resArr.map(({ data }) => data);

        const flatArr = (_flatten(dataArr) || []).map(
          ({ entity_uuid, entity_name }) => ({
            value: entity_uuid,
            label: entity_name
          })
        );
        presenter_presentations_array = flatArr;
        console.log('%%%%%%DATA ARR%%%%%%', dataArr);
        // setDataArray(dataArr);
        setPresentersArr(data);
        setPresenterArrAddToPk(addPresenterToPk);
      }

      // get event presentations
      let userPresentationsArray = [];
      let submitted_presentations_array = [];
      let selectedPresentersData = {};

      if (pkDataRes.data) {
        let apiDataRes = pkDataRes.data;
        console.log('******API DATA RES!!!!!!!!!', apiDataRes);
        let tempFilArr = [];
        let tmp_accepted_pk_array = [];
        let tmp_submitted_pk_array = [];
        if (apiDataRes.length > 0) {
          apiDataRes.forEach((item) => {
            //console.log("FOUND PK",item);
            if (!item.xref_data || !('visibility_integer' in item.xref_data)) {
              item.visibility_integer = 1;
            } else {
              item.visibility_integer = item.xref_data.visibility_integer;
            }
            if (
              item.xref_data &&
              item.xref_data.order_integer &&
              item.xref_data.order_integer > 0
            ) {
              tmp_accepted_pk_array.push(item);
            } else if (
              item.xref_data &&
              item.xref_data.submitted_time &&
              !item.xref_data.rejected_time
            ) {
              tmp_submitted_pk_array.push(item);
            }
          });
        }
        tmp_accepted_pk_array.sort(
          (a, b) =>
            parseFloat(a.xref_data.order_integer) -
            parseFloat(b.xref_data.order_integer)
        );
        tmp_submitted_pk_array.sort(
          (a, b) =>
            parseFloat(a.xref_data.submitted_time) -
            parseFloat(b.xref_data.submitted_time)
        );

        // get user information for each presentation in event
        const accepted_presentation_users_promises = tmp_accepted_pk_array.map(
          ({ entity_uuid }) =>
            axios.get(
              `${presentation_Creation_API}/${entity_uuid}/users`,
              myHeaders_Auth_With_Cache_Control
            )
        );
        const submitted_presentation_users_promises =
          tmp_submitted_pk_array.map(({ entity_uuid }) =>
            axios.get(
              `${presentation_Creation_API}/${entity_uuid}/users`,
              myHeaders_Auth_With_Cache_Control
            )
          );
        let [
          accepted_pks_users_results_array,
          submitted_pks_users_results_array
        ] = await Promise.all([
          Promise.all(accepted_presentation_users_promises),
          Promise.all(submitted_presentation_users_promises)
        ]);
        //console.log("YO",accepted_pks_users_results_array,submitted_pks_users_results_array);
        //const data = res.map(({ data }) => data);

        accepted_pks_users_results_array.forEach(
          (accepted_pks_users_result, index) => {
            let val = accepted_pks_users_result.data;
            // eslint-disable-next-line
            let editable = val.some((val2) => {
              if (
                val2.xref_data &&
                val2.xref_data.entity_owner_integer &&
                val2.xref_data.entity_owner_integer >= 1
              ) {
                return val2.entity_uuid === user_entity_uuid;
              }
            });
            // override editable if user is admin
            if (user_access_level === 'admin') {
              editable = true;
            }
            // eslint-disable-next-line
            const selectedPresenter = val
              .filter((val2) => {
                if (val2.xref_data && val2.xref_data.presenter_integer) {
                  return val2.xref_data.presenter_integer === 1;
                }
              })
              .map(({ entity_uuid, firstname, lastname }) => {
                return {
                  label: `${firstname} ${lastname}`,
                  value: entity_uuid,
                  color: '#666666'
                };
              });
            tmp_accepted_pk_array[index].selectedPresenter = selectedPresenter;
            tmp_accepted_pk_array[index].label =
              tmp_accepted_pk_array[index].entity_name;
            tmp_accepted_pk_array[index].editable = editable;
          }
        );

        const selectedPresenters = {};
        tmp_accepted_pk_array.forEach(
          ({ label, selectedPresenter, entity_uuid }) => {
            selectedPresenters[label] = {
              data: selectedPresenter,
              entity_uuid
            };
          }
        );
        userPresentationsArray = tmp_accepted_pk_array;
        selectedPresentersData = selectedPresenters;

        submitted_pks_users_results_array.forEach(
          (submitted_pks_users_result, index) => {
            let val = submitted_pks_users_result.data;

            let editable = val.some((val2) => {
              if (
                val2.xref_data &&
                val2.xref_data.entity_owner_integer &&
                val2.xref_data.entity_owner_integer >= 1
              ) {
                return val2.entity_uuid === user_entity_uuid;
              }
            });
            // override editable if user is admin
            if (user_access_level === 'admin') {
              editable = true;
            }
            let selectedPresenterShort = val.filter((val2) => {
              if (val2.xref_data && val2.xref_data.presenter_integer) {
                return val2.xref_data.presenter_integer === 1;
              }
            })[0];

            let selectedPresenter = val
              .filter((val2) => {
                if (val2.xref_data && val2.xref_data.presenter_integer) {
                  return val2.xref_data.presenter_integer === 1;
                }
              })
              .map(({ entity_uuid, firstname, lastname }) => {
                return {
                  label: `${firstname} ${lastname}`,
                  value: entity_uuid,
                  color: '#666666'
                };
              });

            tmp_submitted_pk_array[index].selectedPresenter = selectedPresenter;
            tmp_submitted_pk_array[index].selectedPresenterShort =
              selectedPresenterShort;
            tmp_submitted_pk_array[index].label =
              tmp_submitted_pk_array[index].entity_name;
            tmp_submitted_pk_array[index].editable = editable;
          }
        );
        submitted_presentations_array = tmp_submitted_pk_array;
        submitted_presentations_array = submitted_presentations_array.filter(
          (item) => item.selectedPresenterShort
        );
      }
      let countryArrTemp = [];
      if (locationCityRes.data) {
        let minified_res = locationCityRes.data.search_query_results;
        // Creating Arrays for all response and all countries list
        minified_res.forEach(function (element) {
          tempArr.push(element.entity_info);
          countryArrTemp.push(element.entity_info.country);
          //cityArrTemp.push(element.entity_info.city_name.trim());
        });
        // Creating unique countries from the list and pushing to countryArr
        countryArrTemp = countryArrTemp.unique().sort();
        // Getting cities from countries list
        //console.log("countryArr",countryArrTemp[0],countryArrTemp.length);
        setCountryArr(countryArrTemp);
        set_city_Data(tempArr);
      }

      // get the current user's resident city
      if (locationDataRes.data) {
        let cityArr = [];
        if (locationDataRes.data.length > 0) {
          tempArr.forEach((item) => {
            if (locationDataRes.data[0].country === item.country) {
              cityArr.push(item.city_name.trim());

              setCityArr(cityArr.unique().sort());
              setCountry(locationDataRes.data[0].country);
              setCity(locationDataRes.data[0].city_name.trim());
              setFirstCity(locationDataRes.data[0].city_name.trim());
              setUserLocationData(locationDataRes.data[0]);
            }
          });
        } else if (countryArrTemp.length > 0) {
          tempArr.forEach((item) => {
            if (countryArrTemp[0] === item.country) {
              cityArr.push(item.city_name);

              setCityArr(cityArr.unique().sort());
              setFirstCity(cityArr[0].trim());
              setUserLocationData(countryArrTemp[0]);
              setCity(cityArr[0].trim());
            }
          });
        }
      }

      // get current user's presentations for the "Add Presentation" dropdown
      let publishDataArray = [];
      if (presentationDataRes.data) {
        let response = presentationDataRes;
        if (response.data.length !== 0) {
          const publishDataTempDepArr = [];
          const publishDataTempArr = [];
          response.data.forEach(function (entity) {
            if (entity.status_code === 1) {
              const start_time = unixDateConversion(entity.created_time);
              const start_time_conv = dateConvert(start_time);
              publishDataTempArr.push({
                entity_name: entity.entity_name,
                friendly_url: entity.friendly_url,
                entity_uuid: entity.entity_uuid
              });
              publishDataTempDepArr.push({
                value: entity.entity_uuid,
                label: entity.entity_name
              });
            }
          });
          publishDataArray = publishDataTempDepArr;
          setUserOwnedPresentations(publishDataTempArr);
        }
      }

      // get the event's location
      let eventLocationOriginRes = {
        data: [props.source_info]
      };
      if (eventLocationOriginRes.data) {
        let resData = eventLocationOriginRes.data;
        if (resData && resData[0]) {
          setLocationData(resData[0]);
        }
      }
      let addPresentationList = publishDataArray.concat(
        presenter_presentations_array
      );
      addPresentationList = _differenceBy(
        addPresentationList,
        userPresentationsArray,
        'label'
      );
      setLoading(false);
      setPublishData(publishDataArray);
      setAddPresentationList(addPresentationList);
      setUserPresentations(userPresentationsArray);
      set_submitted_presentations(submitted_presentations_array);
      setSelectedPresenters(selectedPresentersData);
    })();
  }, []);
  //**END OF useEffect FUNCTION****
*/

  /*
  //get presenters in event
  async function getEventUsers() {
    let event_uuid = props.event_uuid;
    let response = await axios.get(
      `${events_list_api}/${event_uuid}/users?limit=500&sort_obj=${encodeURIComponent(
        '{"presenter_order_integer":"asc"}'
      )}&filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}`,
      myHeaders_Auth_With_Cache_Control
    );

    let data = response.data.map((data) => {
      return {
        presenter_name: `${data.firstname} ${data.lastname}`,
        presenter_friendly_url: data.friendly_url,
        entity_uuid: data.entity_uuid,
        avatar_image_url: data.avatar_image_url
      };
    });
    let addPresenterToPk = response.data.map((data) => {
      return {
        label: `${data.firstname} ${data.lastname}`,
        value: data.entity_uuid
      };
    });
    setPresentersArr(data);
    setPresenterArrAddToPk(addPresenterToPk);
    return response.data;
  }
  */

  /*
  // get presentations in event
  async function getEventPks() {
    let event_uuid = props.event_uuid;
    let response = await axios.get(
      `${events_list_api}/${event_uuid}/presentations?limit=1000`,
      myHeaders_Auth_With_Cache_Control
    );

    if (response.data) {
      let apiDataRes = response.data;
      let tempFilArr = [];
      if (apiDataRes.length > 0) {
        apiDataRes.forEach((item) => {
          if (
            item.xref_data &&
            item.xref_data.order_integer &&
            item.xref_data.order_integer > 0
          ) {
            tempFilArr.push(item);
          }
        });
      }
      let resData = tempFilArr;
      resData.sort(
        (a, b) =>
          parseFloat(a.xref_data.order_integer) -
          parseFloat(b.xref_data.order_integer)
      );
      // find presenters for presentations
      const get_presenters_per_presentation_promises = resData.map(
        ({ entity_uuid }) =>
          axios.get(
            `${presentation_Creation_API}/${entity_uuid}/users`,
            myHeaders_Auth_With_Cache_Control
          )
      );
      let res = await Promise.all(get_presenters_per_presentation_promises);
      // eslint-disable-next-line
      const data = res.map(({ data }) => data);
      // eslint-disable-next-line
      data.forEach((val, index) => {
        // eslint-disable-next-line
        let editable = val.some((val2) => {
          if (
            val2.xref_data &&
            val2.xref_data.entity_owner_integer &&
            val2.xref_data.entity_owner_integer >= 1
          ) {
            return val2.entity_uuid === user_entity_uuid;
          }
        });
        // override editable if user is admin
        if (user_access_level === 'admin') {
          editable = true;
        }
        // eslint-disable-next-line
        const selectedPresenter = val
          .filter((val2) => {
            if (val2.xref_data && val2.xref_data.presenter_integer) {
              return val2.xref_data.presenter_integer >= 1;
            }
          })
          .map(({ entity_uuid, firstname, lastname }) => {
            return {
              label: `${firstname} ${lastname}`,
              value: entity_uuid,
              color: '#666666'
            };
          });
        resData[index].selectedPresenter = selectedPresenter;
        resData[index].label = resData[index].entity_name;
        resData[index].editable = editable;
      });
      const selectedPresenters = {};
      resData.forEach(({ label, selectedPresenter, entity_uuid }) => {
        selectedPresenters[label] = {
          data: selectedPresenter,
          entity_uuid
        };
      });
      setUserPresentations(resData, selectedPresenters);
    }
  }
  */

  /*
  // country filter data
  const countryCityFilter = (event) => {
    let cityArr = [];
    if (event.target.id === 'userCountry') {
      setCountry(event.target.value);
      let countryChangeItem = event.target.value;
      tempArr.forEach((item) => {
        if (countryChangeItem === item.country) {
          cityArr.push(item.city_name);
          setCityArr(cityArr.unique().sort());
          setCity(item.city_name);
        }
      });
    } else if (event.target.id === 'userCity') {
      setCity(event.target.value);
    }
  };
  */

  /*
  // Change Avatar method
  const onChangeFile = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
      let files = event.target.files;
      var pictures = [];
      var index;
      for (index = 0; index < files.length; index++) {
        var file = files[index];
        // this.handleLoadImage(file);
        const reader = new FileReader();
        // eslint-disable-next-line
        reader.onloadend = () => {
          setImagePreviewUrl(reader.result);
          pictures.push({ image: file, imagePreviewUrl: reader.result });
        };
        reader.readAsDataURL(file);
      }
      setFile(file); /// if you want to upload latter
    }
  };
  let onChangeImage = onChangeFile();
  */

  /*
  // this is actually callback from PresenterTable to remove a presenter
  const onGetPresenterData = async (data) => {
    let event_uuid = props.event_uuid;
    await axios.patch(`${events_list_api}/${event_uuid}`, {
      users: [
        {
          xref_data: {
            presenter_integer: -1
          },
          entity_uuid: data.userData.entity_uuid
        }
      ]
    });
    if (props.event_info.zoom_webinar_id) {
      axios.post(`${apiUrl}events/${event_uuid}/syncZoomInfo`, {});
    }

    let resData = await getEventUsers();
    //console.log("onGetPresenterData 2",resData);
    //const presenter_presentations_promises = resData.map(({ entity_uuid }) => axios.get(`${user_API}/${entity_uuid}/presentations?filter[status_code][eq]=1&filter[presenter_integer][gte]=1&sort[created_time]=desc&limit=100`, myHeaders_With_Cache_Control));

    let user_presentations_filter_obj = {
      status_code: {
        eq: 1
      },
      presenter_integer: {
        gte: 1
      }
    };
    if (
      props.event_info.event_presentation_format &&
      props.event_info.event_presentation_format !== 'any'
    ) {
      let [slide_count, slide_length] =
        props.event_info.event_presentation_format.split('x');
      user_presentations_filter_obj.slide_count = { eq: slide_count };
      user_presentations_filter_obj.slide_length = { eq: slide_length };
    }

    const presenter_presentations_promises = resData.map(({ entity_uuid }) =>
      axios.get(
        `${user_API}/${entity_uuid}/presentations?sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&filter_obj=${encodeURIComponent(
          JSON.stringify(user_presentations_filter_obj)
        )}&limit=1000`,
        myHeaders_Auth_With_Cache_Control
      )
    );
    let resArr = await Promise.all(presenter_presentations_promises);

    const dataArr = resArr.map(({ data }) => data);
    const flatArr = (_flatten(dataArr) || []).map(
      ({ entity_uuid, entity_name }) => ({
        value: entity_uuid,
        label: entity_name
      })
    );

    let addPresentationList = publishData.concat(flatArr);
    addPresentationList = _differenceBy(
      addPresentationList,
      userPresentations,
      'label'
    );
    //console.log("onGetPresenterData 3",JSON.stringify(addPresentationList,null,2));
    setAddPresentationList(addPresentationList);
  };
  */

  /*
  const uploadPutImage = async (file, upload_url, content_type) => {
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    let profilePicPromise;
    // getting array buffer in profilePicPromise
    profilePicPromise = new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => resolve(reader.result);
    });
    let profilePicPromise_response = await profilePicPromise;
    const config = {
      headers: { 'Content-Type': content_type }
    };
    await axios.put(upload_url, profilePicPromise_response, config);
  };
  */

  /*
  // finish "Create New Presenter" component
  const onGetNewPresenterData = async (data) => {
    setCreatePresenterLoader(true);
    setUserCollisionError(null);
    // Calling API's user_API to get getUploadSignedUrl first
    const collisonCheck = {
      email: data.email
    };
    if (data !== undefined) {
      let res = await axios.post(
        `${user_API}/checkUniqueCollision`,
        collisonCheck,
        HeaderConfig
      );
      if (res.data.email !== true) {
        // JBB - 10/26/2019 - adding extra params to make welcome email work
        data.custom_inviter_text = 'a PechaKucha Event Organizer';
        data.custom_invitation_text = ' to be a Presenter';
        let callback_base_url = get_link_base_url();
          //window.location.protocol + '//' + window.location.hostname + '/';
        data.callback_url = callback_base_url + 'resetpassword';
        let friendly_url = `${data.firstname}-${data.lastname}`;
        data.friendly_url = friendly_url.toLowerCase().replace(/ /g, '-');
        data.custom_inviter_text = firstname + ' ' + lastname;

        if (props.descriptionData && props.descriptionData.entity_name) {
          data.custom_invitation_text =
            ' to present at ' + props.descriptionData.entity_name;
        }

        // Actual API call starts here
        // must treat this like a combined getUploadSignedUrl
        let response;
        if (file) {
          response = await axios.post(
            `${user_API}/register/nopassword?asset_type=avatar_image&filename=${file.name}`,
            data
          );
          let upload_url = response.data.upload_url;
          let content_type = response.data.content_type;
          await uploadPutImage(file, upload_url, content_type);
        } else {
          response = await axios.post(`${user_API}/register/nopassword`, data);
        }
        let userId = response.data.entity_uuid;
        let event_uuid = props.event_uuid;
        if (userId) {
          let data = await axios.patch(`${events_list_api}/${event_uuid}`, {
            users: [
              {
                xref_data: {
                  presenter_integer: 1
                },
                entity_uuid: userId
              }
            ]
          });
          if (props.event_info.zoom_webinar_id) {
            axios.post(`${apiUrl}events/${event_uuid}/syncZoomInfo`, {});
          }

          if (data.data.message === 'success' || data.data.entity_uuid) {
            setCreatePresenterLoader(false);
            await getEventUsers();
          }
          onClickToggleAddUser();
          setSuccessFormData(1);
          window.scrollBy(0, -100);
        }
        // Actual API call ends here
      } else {
        setCreatePresenterLoader(false);
        setUserCollisionError(
          res.data.email === true
            ? 'Sorry, this email is already associated with an existing account'
            : null
        );
      }
    }
  };
  */

  const handleTypeHeadSearch = async (query) => {
    // let key = 'isAddPresenters';
    // this.setState({ [key]: true });
    setIsAddPresenters(true);
    let response_data = await axios.get(
      `${searchUrl}sitesearch?entity_type=users&q=${query}&limit=10`,
      myHeaders_Autorized
    );
    let data = response_data.data;
    if (data.search_query_results.length > 0) {
      const options = [];
      data.search_query_results.forEach(({ entity_info = {} }) => {
        let option_obj = {
          entity_name: entity_info.entity_name,
          friendly_url: entity_info.friendly_url,
          entity_uuid: entity_info.entity_uuid,
          typed_query: query // this makes search-by-email work w/o returning email address
        };
        options.push(option_obj);
      });
      // this.setState({ options, [key]: false });
      setOptions(options);
      setIsAddPresenters(false);
    } else {
      // this.setState({ [key]: false });
      setIsAddPresenters(false);
    }
  };

  // Method for adding selected presenters to table - also called after CreateNewUser Modal finish
  const onAddPresentersChange = async (selectedVal = []) => {
    setAddingPerson(true);
    if (selectedVal[0].entity_uuid) {
      let user_uuid = selectedVal[0].entity_uuid;
      let event_uuid = props.event_uuid;
      await axios.patch(`${events_list_api}/${event_uuid}`, {
        users: [
          {
            xref_data: {
              presenter_integer: 1,
              presenter_order_integer: event_presenters_array.length + 1
            },
            entity_uuid: user_uuid
          }
        ]
      });
      if (props.event_info.zoom_webinar_id) {
        axios.post(`${apiUrl}events/${event_uuid}/syncZoomInfo`, {});
      }

      /*
      if (patch_event_presenter_response.data.message === 'success') {
        // presenter_typeahead_ref.current.clear();
        
        let resData = await getEventUsers();
        let user_presentations_filter_obj = {
          status_code: {
            eq: 1
          },
          presenter_integer: {
            gte: 1
          }
        };
        if (
          props.event_info.event_presentation_format &&
          props.event_info.event_presentation_format !== 'any'
        ) {
          let [slide_count, slide_length] =
            props.event_info.event_presentation_format.split('x');
          user_presentations_filter_obj.slide_count = { eq: slide_count };
          user_presentations_filter_obj.slide_length = { eq: slide_length };
        }
        setShow(false);
        const presenter_presentations_promises = resData.map(
          ({ entity_uuid }) =>
            axios.get(
              `${user_API}/${entity_uuid}/presentations?sort_obj=${encodeURIComponent(
                '{"created_time":"desc"}'
              )}&filter_obj=${encodeURIComponent(
                JSON.stringify(user_presentations_filter_obj)
              )}&limit=1000`,
              myHeaders_Auth_With_Cache_Control
            )
        );
        let resArr = await Promise.all(presenter_presentations_promises);

        const dataArr = resArr.map(({ data }) => data);
        const flatArr = (_flatten(dataArr) || []).map(
          ({ entity_uuid, entity_name }) => ({
            value: entity_uuid,
            label: entity_name
          })
        );

        let addPresentationList = publishData.concat(flatArr);
        addPresentationList = _differenceBy(
          addPresentationList,
          userPresentations,
          'label'
        );
        setAddPresentationList(addPresentationList);
      }
      */
      
      // send email to presenter to let them know they got added
      let link_base_url = get_link_base_url();
      
      // let link_base_url =
      //   window.location.protocol + '//' + window.location.hostname + '/';
      // if (
      //   window.location.hostname === 'localhost' &&
      //   window.location.port === '3000'
      // ) {
      //   link_base_url =
      //     window.location.protocol +
      //     '//' +
      //     window.location.hostname +
      //     ':' +
      //     window.location.port +
      //     '/';
      // }
      
      let event_url =
        '$link_base_url$' +
        local_routes.events.slice(1) +
        '/' +
        props.event_info.friendly_url;
      if (props.event_info.status_code !== 1) {
        event_url = '$link_base_url$' + local_routes.events.slice(1);
      }
      let my_pks_url = '$link_base_url$' + local_routes.pklist.slice(1);
      let account_settings_url =
        '$link_base_url$' + local_routes.accountsettings.slice(1);
      let pkcreation_url = '$link_base_url$' + local_routes.pkcreation.slice(1);
      let email_template_data = {
        subject:
          'Invitation to be a Presenter at Event ' +
          props.event_info.entity_name,
        information:
          'You have been invited by ' + context.user_info.nickname +
          ' to be a presenter at the PechaKucha Event ' +
          props.event_info.entity_name +
          '.<br/>Your next step is to make a great presentation with PK Create, and then submit it to the event.',
        more_information:
          "More information about this event can be found <a href='" +
          event_url +
          "'>here</a>.<br/>Create a presentation <a href='" +
          pkcreation_url +
          "'>here</a>.<br/>All of your presentation information can be found <a href='" +
          my_pks_url +
          "'>here</a>.",
        account_settings_url
      };

      let email_notification_post_obj = {
        email_template_data,
        user_uuid: user_uuid,
        email_template_name:
          'ses_email_triggered-presentation_event_notification',
        link_base_url
      };

      axios.post(
        `${apiUrl}users/sendTemplateEmail`,
        email_notification_post_obj
      );
    }
    setAddingPerson(false);
    
    handleClose();
    
    getEventPresenterData();
    
    // presenter_typeahead_ref.current.clear();
  };

  // Method for adding selected Presentations to table
  // const getSelectedPk = async (item) => {
  //   let totalPkLen = userPresentations.length + 1;
  //   let presentation_uuid = item.value;
  //   //LCK dont need this
  //   if (userPresentations.some((e) => e.entity_uuid === presentation_uuid)) {
  //     // already added - do not add duplicate
  //     return;
  //   }
  //   // must find out if this presentation is editable
  //   let editable = false;
  //   if (
  //     userOwnedPresentations.some((e) => e.entity_uuid === presentation_uuid)
  //   ) {
  //     editable = true;
  //   }
  //   let event_uuid = props.event_uuid;
  //   let patch_promises = [];
  //   let event_patch_obj = {
  //     trigger_create_event_pptx: true,
  //     presentations: [
  //       {
  //         xref_data: {
  //           accepted_time: Math.floor(new Date().getTime() / 1000),
  //           order_integer: totalPkLen
  //         },
  //         entity_uuid: presentation_uuid
  //       }
  //     ]
  //   };
  //   patch_promises.push(
  //     axios.patch(`${events_list_api}/${event_uuid}`, event_patch_obj)
  //   );
  //   let source_patch_obj = {
  //     presentations: [
  //       {
  //         entity_uuid: presentation_uuid,
  //         xref_data: {
  //           added_time: get_current_unix_stamp()
  //         }
  //       }
  //     ]
  //   };
  //   if (
  //     (props.source_info.entity_type === 'locations' ||
  //       props.source_info.entity_type === 'channels') &&
  //     (source_owner || user_access_level === 'admin')
  //   ) {
  //     patch_promises.push(
  //       axios.patch(
  //         `${apiUrl}${props.source_info.entity_type}/${props.source_info.entity_uuid}`,
  //         source_patch_obj
  //       )
  //     );
  //   }
  //   //LCK don't need this if statement below
  //   if (editable) {
  //     // JBB - if current user is listed as a presenter and current user is owner, remove current user as presenter
  //     //  - I don't like this any longer
  //     let presentation_patch_obj = {};
  //     if (props.source_info.entity_type === 'locations') {
  //       presentation_patch_obj.locations_text = props.source_info.entity_name;
  //     }
  //     if (props.source_info.entity_type === 'channels') {
  //       presentation_patch_obj.channels_text = props.source_info.entity_name;
  //     }

  //     if (Object.keys(presentation_patch_obj).length > 0) {
  //       patch_promises.push(
  //         axios.patch(
  //           `${presentation_Creation_API}/${presentation_uuid}`,
  //           presentation_patch_obj
  //         )
  //       );
  //     }
  //   }
  //   let patch_response_array = await Promise.all(patch_promises);
  //   if (patch_response_array[0].data.message === 'success') {
  //     const list = _differenceBy(addPresentationList, [item], 'label');
  //     setAddPresentationList(list);
  //     setSelectedPresentation([]);
  //     await getEventPks();
  //   }
  // };
  //LCK LOOK ABOVE AND BELOW
  // Method to remove selected Presentation
  // const getRmPkData = async (data) => {
  //   let event_uuid = props.event_uuid;
  //   let presentation_uuid = data.entity_uuid;
  //   // delete the presentation xref from event and location
  //   let remove_promises = [];
  //   remove_promises.push(
  //     axios.delete(
  //       `${events_list_api}/${event_uuid}/presentations/${presentation_uuid}`
  //     )
  //   );
  //   let patch_obj = {
  //     trigger_create_event_pptx: true
  //   };
  //   remove_promises.push(
  //     axios.patch(`${events_list_api}/${event_uuid}`, patch_obj)
  //   );
  //   await Promise.all(remove_promises);
  //   setAddPresentationList([
  //     ...addPresentationList,
  //     { label: data.entity_name, value: data.entity_uuid }
  //   ]);
  //   await getEventPks();
  // };

  // getAddPkPeople method for adding people to presentations
  // const getAddPkPeople = async (presenter_uuid, entity_uuid) => {
  //   // we also need to add the presenter as owner of the related slides
  //   let slides_response = await axios.get(
  //     `${apiUrl}presentations/${entity_uuid}/slides?attributes_array=${encodeURIComponent(
  //       '["entity_uuid"]'
  //     )}&filter_obj=${encodeURIComponent('{"order_integer":{"gte":1}}')}`,
  //     myHeaders_Auth_With_Cache_Control
  //   );

  //   let slides_array = slides_response.data;

  //   let update_promise_array = [];

  //   let patch_obj = {
  //     trigger_create_presentation_pptx: true,
  //     users: [
  //       {
  //         xref_data: {
  //           presenter_integer: 1,
  //           entity_owner_integer: 2
  //         },
  //         entity_uuid: presenter_uuid
  //       }
  //     ]
  //   };
  //   update_promise_array.push(
  //     axios.patch(`${presentation_Creation_API}/${entity_uuid}`, patch_obj)
  //   );

  //   for (let slide_obj of slides_array) {
  //     let slide_patch_obj = {
  //       users: [
  //         {
  //           xref_data: {
  //             entity_owner_integer: 2
  //           },
  //           entity_uuid: presenter_uuid
  //         }
  //       ]
  //     };
  //     update_promise_array.push(
  //       axios.patch(`${apiUrl}slides/${slide_obj.entity_uuid}`, slide_patch_obj)
  //     );
  //   }
  //   await Promise.all(update_promise_array);
  // };

  // getRmPkPeople method for removing people from presentations
  // const getRmPkPeople = async (presenter_uuid, entity_uuid) => {
  //   let patch_obj = {
  //     users: [
  //       {
  //         xref_data: {
  //           presenter_integer: -1
  //         },
  //         entity_uuid: presenter_uuid
  //       }
  //     ]
  //   };
  //   await axios.patch(`${presentation_Creation_API}/${entity_uuid}`, patch_obj);
  // };

  // const getSelectedPresenters = (key, data = [], entity_uuid) => {
  //   changesPresenterKey = key;
  //   if (!data) {
  //     data = [];
  //   }
  //   //no idea how to set this state with the preState
  //   setSelectedPresenters({
  //     ...selectedPresenters,
  //     [key]: {
  //       data: [...data],
  //       entity_uuid
  //     }
  //   });
  // };

  // componentDidUpdate = async function (_, prevState) {
  //   const { selectedPresenters } = this.state;
  //   //console.log("componentDidUpdate", selectedPresenters);
  //   //console.log("TESTS",Object.keys(prevState.selectedPresenters).length,prevState.selectedPresenters[this.changesPresenterKey],selectedPresenters[this.changesPresenterKey],prevState.selectedPresenters[this.changesPresenterKey].data,selectedPresenters[this.changesPresenterKey].data);
  //   if (this.changesPresenterKey) {
  //     if (
  //       Object.keys(prevState.selectedPresenters).length &&
  //       prevState.selectedPresenters[this.changesPresenterKey] &&
  //       selectedPresenters[this.changesPresenterKey] &&
  //       prevState.selectedPresenters[this.changesPresenterKey].data &&
  //       selectedPresenters[this.changesPresenterKey].data &&
  //       !_isEqual(
  //         prevState.selectedPresenters[this.changesPresenterKey].data,
  //         selectedPresenters[this.changesPresenterKey].data
  //       )
  //     ) {
  //       if (
  //         selectedPresenters[this.changesPresenterKey].data.length >
  //         prevState.selectedPresenters[this.changesPresenterKey].data.length
  //       ) {
  //         // For add
  //         if (
  //           !prevState.selectedPresenters[this.changesPresenterKey].data.length
  //         ) {
  //           const { data, entity_uuid } =
  //             selectedPresenters[this.changesPresenterKey];
  //           this.getAddPkPeople(data[0].value, entity_uuid);
  //         } else {
  //           const { data, entity_uuid } =
  //             selectedPresenters[this.changesPresenterKey];
  //           const { data: prevData } =
  //             prevState.selectedPresenters[this.changesPresenterKey];
  //           const getAddedPresenter = _differenceBy(data, prevData, 'value');
  //           this.getAddPkPeople(getAddedPresenter[0].value, entity_uuid);
  //         }
  //       } else if (
  //         selectedPresenters[this.changesPresenterKey].data.length <
  //         prevState.selectedPresenters[this.changesPresenterKey].data.length
  //       ) {
  //         // For delete
  //         if (!selectedPresenters[this.changesPresenterKey].data.length) {
  //           const { data, entity_uuid } =
  //             prevState.selectedPresenters[this.changesPresenterKey];
  //           this.getRmPkPeople(data[0].value, entity_uuid);
  //         } else {
  //           const { data, entity_uuid } =
  //             selectedPresenters[this.changesPresenterKey];
  //           const { data: prevData } =
  //             prevState.selectedPresenters[this.changesPresenterKey];
  //           const getDeletedPresenter = _differenceBy(prevData, data, 'value');
  //           this.getRmPkPeople(getDeletedPresenter[0].value, entity_uuid);
  //         }
  //       }
  //     } else {
  //       const { data, entity_uuid } =
  //         selectedPresenters[this.changesPresenterKey];
  //       this.getAddPkPeople(data[0].value, entity_uuid);
  //     }
  //     this.changesPresenterKey = '';
  //   }

  //   // this logic is very weird...I think since we switched componentDidMount to use async/await, we don't need the first time / APIdone thing
  //   /*
  //         console.log("componentDidUpdate",this.isFirstTime,this.state.userPresentationsAPIdone,publishData.length,userPresentations.length);
  //         if (!this.isFirstTime && this.state.userPresentationsAPIdone) {
  //             if (publishData.length && userPresentations.length) {
  //                 console.log("YO1");
  //                 const addPresentationList = _differenceBy(publishData, userPresentations, 'label');
  //                 this.setState({ addPresentationList });
  //                 console.log("SET addPresentationList 1",JSON.stringify(addPresentationList,null,2));
  //             } else if (publishData.length) {
  //                 console.log("SET addPresentationList 2",JSON.stringify(publishData,null,2));
  //                 this.setState({ addPresentationList: publishData });
  //             }
  //             this.isFirstTime = true;
  //         }
  //         */

  //   /*
  //         if (publishData.length && userPresentations.length) {
  //             console.log("YO1");
  //             const addPresentationList = _differenceBy(publishData, userPresentations, 'label');
  //             this.setState({ addPresentationList });
  //             console.log("SET addPresentationList 1",JSON.stringify(addPresentationList,null,2));
  //         } else if (publishData.length) {
  //             console.log("SET addPresentationList 2",JSON.stringify(publishData,null,2));
  //             this.setState({ addPresentationList: publishData });
  //         }
  //         */
  // };

  const finalCreateEvent = async () => {
    let next_page = `${workspace_base_url}${local_routes.myevents}`;
    if (props.source_info.referrer) {
      next_page = props.source_info.referrer;
    }
    props.history.push(next_page);
  };

  // for re-ordering presentations
  const onDragEndPresenters = async (result) => {
    if (!result.destination) {
      return;
    }
    const items = reConstructData(
      //presentersArr,
      event_presenters_array,
      result.source.index,
      result.destination.index
    );
    //setPresentersArr(items);
    setEventPresentersArray(items);
    
    let event_uuid = props.event_uuid;

    let patch_presenters_order_array = [];
    let patch_presentations_order_array = [];
    items.forEach((item, i) => {
      patch_presenters_order_array.push({
        xref_data: {
          presenter_order_integer: i + 1
        },
        entity_uuid: item.entity_uuid
      });
      if (item.presentation_info) {
        patch_presentations_order_array.push({
          xref_data: {
            order_integer: i + 1
          },
          entity_uuid: item.presentation_info.entity_uuid
        });
      }
    });

    let patch_obj = {
      //"trigger_create_event_pptx": true,
      users: patch_presenters_order_array,
      presentations: patch_presentations_order_array
    };
    await axios.patch(`${events_list_api}/${event_uuid}`, patch_obj);
  };

  // for re-ordering presentations
  // const onDragEnd = async (result) => {
  //   if (!result.destination) {
  //     return;
  //   }
  //   const items = reConstructData(
  //     userPresentations,
  //     result.source.index,
  //     result.destination.index
  //   );
  //   items.forEach((val) => {
  //     const updatedPresenters = _pickBy(selectedPresenters, (_, key) => {
  //       return _startsWith(key, val.entity_name);
  //     });
  //     val.selectedPresenter =
  //       updatedPresenters[val.entity_name] &&
  //       updatedPresenters[val.entity_name].data
  //         ? updatedPresenters[val.entity_name].data
  //         : [];
  //   });
  //   setUserPresentations(items);
  //   let event_uuid = props.event_uuid;

  //   let patch_presentation_order_array = [];
  //   items.forEach((item, i) => {
  //     patch_presentation_order_array.push({
  //       xref_data: {
  //         order_integer: i + 1
  //       },
  //       entity_uuid: item.entity_uuid
  //     });
  //   });
  //   let patch_obj = {
  //     trigger_create_event_pptx: true,
  //     presentations: patch_presentation_order_array
  //   };
  //   await axios.patch(`${events_list_api}/${event_uuid}`, patch_obj);
  // };

  // when a submitted PK is rejected; also called to remove orphaned PKs from event
  const onRejectPK = async (rejected_presentation_obj) => {
    let new_submitted_presentations = submitted_presentations_array.filter(
      (item, i) => {
        if (item.entity_uuid === rejected_presentation_obj.entity_uuid) {
          return false;
        } else {
          return true;
        }
      }
    );
    let new_orphaned_presentations = orphaned_presentations_array.filter(
      (item, i) => {
        if (item.entity_uuid === rejected_presentation_obj.entity_uuid) {
          return false;
        } else {
          return true;
        }
      }
    );


    // unshift into userPresentations
    //set_submitted_presentations(new_submitted_presentations);
    setSubmittedPresentationsArray(new_submitted_presentations);
    setOrphanedPresentationsArray(new_orphaned_presentations);

    let patch_obj = {
      presentations: [
        {
          xref_data: {
            rejected_time: Math.floor(new Date().getTime() / 1000),
            order_integer: -1 // should not be necessary, but just in case
          },
          entity_uuid: rejected_presentation_obj.entity_uuid
        }
      ]
    };
    await axios.patch(`${apiUrl}events/${props.event_uuid}`, patch_obj);
  };

  /*
  const toggleVisibility = async (presentation_obj, index) => {
    console.log('toggleVisibility', presentation_obj, index);
    let tmp_userPresetations = userPresentations;
    if (tmp_userPresetations[index].visibility_integer) {
      tmp_userPresetations[index].visibility_integer = 0;
    } else {
      tmp_userPresetations[index].visibility_integer = 1;
    }
    setUserPresentations(tmp_userPresetations);

    let patch_obj = {
      presentations: [
        {
          entity_uuid: presentation_obj.entity_uuid,
          xref_data: {
            visibility_integer: tmp_userPresetations[index].visibility_integer
          }
        }
      ]
    };

    await axios.patch(`${apiUrl}events/${props.event_uuid}`, patch_obj);

    //bust cache
    let event_presentations_params = {
      do_recursive: true,
      filter_obj: {
        order_integer: {
          gte: 1
        }
      },
      sort_obj: {
        order_integer: 'asc'
      }
    };
    axios.get(
      `${apiUrl}events/${props.event_info.friendly_url}/presentations`,
      {
        params: event_presentations_params,
        ...myHeaders_Auth_With_Cache_Control
      }
    );
  };
  */

  // called when submitted presentations are accepted; also called when orphaned presentations are added properly
  const onAcceptPK = async (accepted_presentation_obj, presenter_obj) => {
    // unshift into userPresentations
    //let event_presentations_array_length = event_presentations_array.length;
    let new_order_integer = event_presenters_array.length + 1;
    
    let new_submitted_presentations = submitted_presentations_array.filter(
      (item, i) => {
        if (item.entity_uuid === accepted_presentation_obj.entity_uuid) {
          return false;
        } else {
          return true;
        }
      }
    );
    let new_orphaned_presentations = orphaned_presentations_array.filter(
      (item, i) => {
        if (item.entity_uuid === accepted_presentation_obj.entity_uuid) {
          return false;
        } else {
          return true;
        }
      }
    );
    //set_submitted_presentations(new_submitted_presentations);
    setSubmittedPresentationsArray(new_submitted_presentations); // just so something happens on page right away
    setOrphanedPresentationsArray(new_orphaned_presentations);
    
    //setUserPresentations([accepted_presentation_obj, ...userPresentations]);
    //setEventPresentationsArray([...event_presentations_array,accepted_presentation_obj]);

    // is the presentation presenter already an event presenter? if so, use existing order integer
    
    let tmp_presenter_index = event_presenters_array.findIndex((item) => item.entity_uuid === presenter_obj.entity_uuid);
    if (tmp_presenter_index >= 0) {
      new_order_integer = tmp_presenter_index + 1;
    }

    // patch accepted_time and order_integer for accepted PK
    let presentations_patch_array = [
      {
        xref_data: {
          accepted_time: Math.floor(new Date().getTime() / 1000),
          order_integer: new_order_integer
        },
        entity_uuid: accepted_presentation_obj.entity_uuid
      }
    ];
    
    // patch users into event as presenters
    let users_patch_array = [
      {
        xref_data: {
          presenter_integer: 1,
          presenter_order_integer: new_order_integer
        },
        entity_uuid: accepted_presentation_obj.presenter_info.entity_uuid
      }
    ];

    /*
    // patch order_integer+1 for the other presentations
    //userPresentations.forEach((presentation_obj, index) => {
    event_presentations_array.forEach((presentation_obj, index) => {
      presentations_patch_array.push({
        xref_data: {
          order_integer: index + 2
        },
        entity_uuid: presentation_obj.entity_uuid
      });
    });
    */
    let patch_obj = {
      presentations: presentations_patch_array,
      users: users_patch_array,
      trigger_create_event_pptx: true
    };
    console.log('onAcceptPK', patch_obj);
    //Johns edit below: adding a second patch for the relevant location(or channel).
    let patch_promises = [];
    //await axios.patch(`${apiUrl}events/${this.props.event_uuid}`, patch_obj);
    patch_promises.push(
      axios.patch(`${apiUrl}events/${props.event_uuid}`, patch_obj)
    );
    //console.log("source owner?",this.state.source_owner,this.props.source_info.entity_type,this.props.source_info.entity_uuid,owner_perms);
    if (
      (props.source_info.entity_type === 'locations' ||
        props.source_info.entity_type === 'channels') &&
      (source_owner_flag || user_access_level === 'admin')
    ) {
      let source_patch_obj = {
        presentations: [
          {
            entity_uuid: accepted_presentation_obj.entity_uuid,
            xref_data: {
              added_time: get_current_unix_stamp()
            }
          }
        ]
      };
      patch_promises.push(
        axios.patch(
          `${apiUrl}${props.source_info.entity_type}/${props.source_info.entity_uuid}`,
          source_patch_obj
        )
      );
    }
    await Promise.all(patch_promises);
    //end Johns edit

    // 7/27/2020 - JBB - added email notification
    // first need to get presentation owner (creator)
    /*
    let creator_response = await axios.get(
      `${apiUrl}presentations/${
        accepted_presentation_obj.entity_uuid
      }/users?filter_obj=${encodeURIComponent(
        '{"entity_owner_integer":{"eq":1}}'
      )}`
    );
    */
    
    //if (creator_response.data && creator_response.data[0]) {
      //let creator_obj = creator_response.data[0];
      

      let link_base_url =
        window.location.protocol + '//' + window.location.hostname + '/';
      if (
        window.location.hostname === 'localhost' &&
        window.location.port === '3000'
      ) {
        link_base_url =
          window.location.protocol +
          '//' +
          window.location.hostname +
          ':' +
          window.location.port +
          '/';
      }
      let event_url =
        '$link_base_url$' +
        local_routes.events.slice(1) +
        '/' +
        props.event_info.friendly_url;
      if (props.event_info.status_code !== 1) {
        event_url = '$link_base_url$' + local_routes.events.slice(1);
      }
      let my_pks_url = '$link_base_url$' + local_routes.pklist.slice(1);
      let account_settings_url =
        '$link_base_url$' + local_routes.accountsettings.slice(1);

      let email_template_data = {
        subject:
          'Presentation ' +
          accepted_presentation_obj.entity_name +
          ' Accepted to ' +
          props.event_info.entity_name,
        information:
          'Your PechaKucha.com presentation ' +
          accepted_presentation_obj.entity_name +
          ' has been accepted to the event ' +
          props.event_info.entity_name +
          '.',
        more_information:
          "More information about this event can be found <a href='" +
          event_url +
          "'>here</a>.<br/>All of your presentation information can be found <a href='" +
          my_pks_url +
          "'>here</a>.",
        account_settings_url
      };

      let email_notification_post_obj = {
        email_template_data,
        //user_uuid: creator_obj.entity_uuid,
        user_uuid: accepted_presentation_obj.presenter_info.entity_uuid,
        email_template_name:
          'ses_email_triggered-presentation_event_notification',
        link_base_url
      };

      axios.post(
        `${apiUrl}users/sendTemplateEmail`,
        email_notification_post_obj
      );
    //}
    
    getEventPresenterData();
  };

  const reConstructData = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const getListStyle = (isDraggingOver) => ({
    padding: 8
  });

  const prevScreen = () => {
    props.history.push(
      `${workspace_base_url}${local_routes.manageevent}/${props.event_uuid}/venue`
    );
  };

  if (loading) {
    return (
      <div className="spinner-pos">
        <FullPageSpinner />
      </div>
    );
  }
  const profilePlaceholder =
    'https://upload.wikimedia.org/wikipedia/commons/2/24/Missing_avatar.svg';
  const centeredData =
    'thead-data px-1 d-flex align-items-center justify-content-center text-center';
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  return (
    <div className="presenters-info pkListContainer eventCreation">
      <ReactTooltip />
      <Row>
        <Col lg={12}>
          <p className="presenters">
            All changes made in this tab are automatically saved. You may
            re-order your presenters and presentations by dragging and dropping.
            <br />
            Recommended workflow:
            <br />
            <React.Fragment>
              &nbsp;1) Use this page to add/create all of your event's
              presenters.
              <br />
              &nbsp;2) After your event has happened, use PK Create to
              create/upload all of your event's presentations, and assign your presenters to the presentations.
              &nbsp;&nbsp;&nbsp;&nbsp;Alternatively, your presenters can create/upload their own presentations and submit them to your event.
              <br />
              &nbsp;3) Once all of the event's presentations are
              created/published, use this page to add them to your event.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;Note that adding a presenter to a
              presentation will also permanently grant them "owner" privileges
              to that presentation.
            </React.Fragment>
          </p>
        </Col>
        
        {submitted_presentations_array.length > 0 && (
          <Col lg={12}>
            <div className="table-boby">
              <Table variant={context.theme} responsive={true}>
                <tbody>
                  <tr className="">
                    <th className="table-caption" colSpan="8">
                      <div className="draftsData">
                        <h4>
                          Submitted Presentations{' '}
                          <span style={{ marginLeft: "3px" }}> ({submitted_presentations_array.length}) </span>
                        </h4>
                      </div>
                    </th>
                  </tr>
                  <tr className="thead">
                    <th className="table-caption d-flex" colSpan="8">
                      <div className="thead-data" style={{ width: '30%' }}>
                        Title
                      </div>
                      <div
                        className="thead-data presenter-pad"
                        style={{ width: '35%' }}>
                        Presenter
                      </div>
                      <div
                        className="thead-data presenter-pad"
                        style={{ width: '15%' }}>
                        &nbsp;
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td className="pad0">
                      <table>
                        <tbody>
                          {submitted_presentations_array.map((item, i) => {
                            return (
                              <SubmittedPresentationTable
                                key={i}
                                index={i}
                                presentation_info={item}
                                presenter_info={item.presenter_info}
                                acceptPK={onAcceptPK}
                                rejectPK={onRejectPK}
                              />
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        )}
        
        {orphaned_presentations_array.length > 0 && (
          <Col lg={12}>
            <div className="table-boby">
              <Table variant={context.theme} responsive={true}>
                <tbody>
                  <tr className="">
                    <th className="table-caption" colSpan="8">
                      <div className="draftsData">
                        <h4>
                          Orphaned Presentations
                          <span style={{ marginLeft: "3px" }}> ({orphaned_presentations_array.length}) </span>
                        </h4>
                        <span style={{ fontWeight: 'lighter', fontStyle:'italic', fontSize: 'smaller', marginLeft: '5px' }}>Event associated presentations without a corresponding event presenter</span>
                      </div>
                    </th>
                  </tr>
                  <tr className="thead">
                    <th className="table-caption d-flex" colSpan="8">
                      <div className="thead-data" style={{ width: '30%' }}>
                        Title
                      </div>
                      <div
                        className="thead-data presenter-pad"
                        style={{ width: '35%' }}>
                        Presenter
                      </div>
                      <div
                        className="thead-data presenter-pad"
                        style={{ width: '15%' }}>
                        &nbsp;
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td className="pad0">
                      <table>
                        <tbody>
                          {orphaned_presentations_array.map((item, i) => {
                            return (
                              <OrphanedPresentationTable
                                key={i}
                                index={i}
                                presentation_info={item}
                                presenter_info={item.presenter_info}
                                acceptPK={onAcceptPK}
                                rejectPK={onRejectPK}
                              />
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        )}
        
        {/* <Col lg={12}>
          <div className="table-boby">
            <Table variant={context.theme} responsive={true}>
              <tbody>
                <tr className="">
                  <th className="table-caption" colSpan="8">
                    <div className="draftsData">
                      <h4>
                        Presenters{' '}
                        <span
                          style={{
                            marginTop: '3px',
                            fontSize: 'smaller',
                            color: 'gray'
                          }}>
                          &nbsp;({presentersArr.length})
                        </span>
                      </h4>
                    </div>
                  </th>
                </tr>
                <tr className="thead">
                  <th className="table-caption d-flex" colSpan="8">
                    <div className="thead-data w-33">Name</div>
                    <div className="thead-data w-33 presenter-pad">Profile</div>
                  </th>
                </tr>
                <DragDropContext onDragEnd={onDragEndPresenters}>
                  <Droppable droppableId="presentations">
                    {(provided, snapshot) => (
                      <tr
                        style={getListStyle(snapshot.isDraggingOver)}
                        ref={provided.innerRef}>
                        <td className="pad0">
                          <table>
                            <tbody>
                              {presentersArr.map((item, i) => {
                                return (
                                  <Draggable
                                    key={item.entity_uuid}
                                    draggableId={item.entity_uuid}>
                                    {(provided, snapshot) => (
                                      <PresenterTable
                                        key={i}
                                        index={i}
                                        event_uuid={props.event_uuid}
                                        presenter_name={item.presenter_name}
                                        source_pathname={
                                          props.location.pathname
                                        }
                                        //presenter_email={item.presenter_email}
                                        presenter_friendly_url={
                                          item.presenter_friendly_url
                                        }
                                        userData={item}
                                        getPresenterData={onGetPresenterData}
                                        provided={provided}
                                        snapshot={snapshot}
                                      />
                                    )}
                                  </Draggable>
                                );
                              })}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </Droppable>
                </DragDropContext>
              </tbody>
            </Table>
          </div>
        </Col> */}

        {/* <Col lg={12}>
          <hr />
        </Col> */}
        {/* <Col lg={12}>
          <div className="table-boby">
            <Table variant={context.theme} responsive={true}>
              <tbody>
                <tr className="">
                  <th className="table-caption" colSpan="8">
                    <div className="draftsData">
                      <h4>
                        Presentations{' '}
                        <span
                          style={{
                            marginTop: '3px',
                            fontSize: 'smaller',
                            color: 'gray'
                          }}>
                          &nbsp;({userPresentations.length})
                        </span>
                      </h4>
                    </div>
                  </th>
                </tr>
                <tr className="thead">
                  <th className="table-caption d-flex" colSpan="8">
                    <div
                      className="thead-data presenter-pad"
                      style={{ width: '30%' }}>
                      Title
                    </div>
                    <div
                      className="thead-data presenter-pad"
                      style={{ width: '30%' }}>
                      Presenters
                    </div>
                    <div
                      className="thead-data presenter-pad"
                      style={{ paddingLeft: '30px', width: '15%' }}>
                      Assets
                    </div>
                    <div
                      className="thead-data presenter-pad"
                      style={{ paddingLeft: '30px', width: '10%' }}>
                      Visibility
                    </div>
                    <div
                      className="thead-data presenter-pad"
                      style={{ width: '15%' }}>
                      &nbsp;
                    </div>
                  </th>
                </tr>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="presentations">
                    {(provided, snapshot) => (
                      <tr
                        style={getListStyle(snapshot.isDraggingOver)}
                        ref={provided.innerRef}>
                        <td className="pad0">
                          <table>
                            <tbody>
                              {userPresentations.map((item, i) => {
                                console.log('********ITEM********', item);
                                return (
                                  <Draggable
                                    key={item.entity_uuid}
                                    draggableId={item.entity_uuid}>
                                    {(provided, snapshot) => (
                                      <PresentationTable
                                        key={i}
                                        index={i}
                                        presentation_info={item}
                                        presenter_title={item.entity_name}
                                        presenters={item.friendly_url}
                                        data={item}
                                        toggleVisibility={toggleVisibility}
                                        presenterArrAddToPk={
                                          presenterArrAddToPk
                                        }
                                        getRmPkData={getRmPkData}
                                        getAddPkPeople={getAddPkPeople}
                                        getRmPkPeople={getRmPkPeople}
                                        getSelectedPresenters={
                                          getSelectedPresenters
                                        }
                                        selectedPresenter={
                                          item.selectedPresenter
                                        }
                                        provided={provided}
                                        snapshot={snapshot}
                                      />
                                    )}
                                  </Draggable>
                                );
                              })}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </Droppable>
                </DragDropContext>
              </tbody>
            </Table>
          </div>
        </Col>
        <Col lg={6}>
          <div className="eventSelect">
            <h5>Add Presentation</h5>
            <EventSelect
              editable={true}
              multiple="false"
              selectedPresenter={selectedPresentation}
              publishData={addPresentationList}
              compStatus="addPresentation"
              getSelectedPk={getSelectedPk}
            />
          </div>
          <p className="presenters">
            Presentation not created yet? Use the 'Create New Presentation'
            button next to each presenter to automatically create new event
            presentations as the specified presenter.
          </p>
        </Col> */}
        {/* LEVIS INSERT STARTS HERE */}
        <Col xs={12}>
          <div className="table-body">
            <Table variant={context.theme} responsive={true}>
              <tbody>
                <tr className="">
                  <th className="table-caption" colSpan="8">
                    <div className="draftsData">
                      <h4>
                        Presenters{' '}
                        <span
                          style={{
                            marginTop: '3px',
                            fontSize: 'smaller',
                            color: 'gray'
                          }}>
                          &nbsp;({event_presenters_array.length})
                        </span>
                      </h4>
                    </div>
                  </th>
                </tr>
                <tr className="thead">
                  <th className="table-caption d-flex px-0" colSpan="8">
                    <div className={`${centeredData}`} style={{ width: '25%' }}>
                      Profile
                    </div>
                    <div className={`${centeredData}`} style={{ width: '25%' }}>
                      Presentation
                    </div>
                    <div className={`${centeredData}`} style={{ width: '10%' }}>
                      Edit Presentation
                    </div>
                    <div className={`${centeredData}`} style={{ width: '10%' }}>
                      Download
                    </div>
                    <div className={`${centeredData}`} style={{ width: '10%' }}>
                      Permission
                    </div>
                    <div className={`${centeredData}`} style={{ width: '10%' }}>
                      Visability
                    </div>
                    <div className={`${centeredData}`} style={{ width: '10%' }}>
                      Remove
                    </div>
                  </th>
                </tr>
                <DragDropContext onDragEnd={onDragEndPresenters}>
                  <Droppable droppableId="presentations">
                    {(provided, snapshot) => (
                      <tr
                        style={getListStyle(snapshot.isDraggingOver)}
                        ref={provided.innerRef}>
                        <td className="p-0">
                          <table>
                            <tbody>
                              {event_presenters_array.map((item, i) => {
                                return (
                                  <Draggable
                                    key={item.entity_uuid}
                                    draggableId={item.entity_uuid}>
                                    {(provided, snapshot) => (
                                      <React.Fragment>
                                        {/* JBB - 8/2/2021 - IMO we want to pass A) current user info (or not, if you want to use context.user_info in the Combo component), B) event info, 
                                               C) current event presentation array (which will include users per presentation, and also probably an "editable" flag set programmatically)
                                               D) source_pathname, which I think is used for the return trip back from the "Edit Presentation" button
                                               E) presenter info (which will include friendly_url and avatar image url)
                                               I think we also want to move functions like addPresentationToEvent, etc. to the Combo component
                                          */}
                                        <PresentationPresenterCombo
                                          //event_presentations={event_presentations_array} // JBB - 8/2/2021
                                          presentation_info={item.presentation_info}
                                          editable={item.presentation_info ? item.presentation_info.editable : false}
                                          presenter_info={item} // JBB - 8/2/2021
                                          event_info={props.event_info} // JBB - 8/2/2021
                                          source_info={props.source_info} // info for parent location/channel
                                          source_owner_flag={source_owner_flag} // does current user also own the location/channel
                                          source_pathname={props.location.pathname} // exact page to come back to
                                          getEventPresenterData={getEventPresenterData}
                                          key={i}
                                          index={i}
                                          event_uuid={props.event_uuid}
                                          
                                          //presenter_name={item.presenter_name}
                                          
                                          
                                          
                                          //presenter_friendly_url={
                                          //  item.presenter_friendly_url
                                          //}
                                          
                                          //avatar_image_url={
                                          //  item.avatar_image_url
                                          //}
                                          
                                          //userData={item}
                                          
                                          //getPresenterData={onGetPresenterData}
                                          
                                          provided={provided}
                                          snapshot={snapshot}
                                          //start props from EventSelect
                                          // selectedPresenter={
                                          //   selectedPresentation
                                          // }
                                          // publishData={addPresentationList}
                                          // getSelectedPk={getSelectedPk}
                                          //passing presentation data
                                          // presentationData={dataArray.filter(
                                          //   (arrayItem, index) =>
                                          //     index === i ? arrayItem : null
                                          // )}
                                          //start props from Presentation Table
                                          
                                          //toggleVisibility={toggleVisibility}
                                          
                                          // presenterArrAddToPk={
                                          //   presenterArrAddToPk
                                          // }
                                          // getRmPkData={getRmPkData}
                                          // getAddPkPeople={getAddPkPeople}
                                          // getRmPkPeople={getRmPkPeople}
                                          // getSelectedPresenters={
                                          //   getSelectedPresenters
                                          // }
                                          //LCK adding stuff to make getSelectedPK to work
                                          //source_info={props.source_info}
                                          //source_owner={source_owner}
                                          //getEventPks={getEventPks}
                                        />
                                      </React.Fragment>
                                    )}
                                  </Draggable>
                                );
                              })}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </Droppable>
                </DragDropContext>
                <tr>
                  <td className="border-none pad0">
                    <table>
                      <tbody>
                        <tr>
                          <td className="border-none" style={{ width: '15%' }}>
                            <span
                              style={{
                                fontSize: 'smaller',
                                color: 'gray'
                              }}>
                              {event_presenters_array.length + 1}
                              {')'}
                            </span>{' '}
                            <img
                              src={profilePlaceholder}
                              alt="nobody yet"
                              style={{
                                height: 'auto',
                                width: '55px',
                                borderRadius: '100%'
                              }}
                            />
                          </td>
                          <td
                            className="border-none d-flex align-self-center my-3"
                            style={{ width: '45%' }}>
                            <Button variant="pkprimary" onClick={handleShow}>
                              Add Presenter
                            </Button>
                            <Modal
                              show={show}
                              onHide={handleClose}
                              animation={false}>
                              <Modal.Header closeButton>
                                <Modal.Title>Add</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                
                                  <AsyncTypeahead
                                    delay={300}
                                    id="PresenterTypeAhead"
                                    labelKey={(option) =>
                                      `${option.entity_name} - ${option.friendly_url}`
                                    }
                                    isLoading={isAddPresenters}
                                    filterBy={[
                                      'typed_query',
                                      'entity_name',
                                      'friendly_url'
                                    ]}
                                    placeholder="Add Presenter"
                                    ref={presenter_typeahead_ref}
                                    minLength={3}
                                    onChange={onAddPresentersChange}
                                    onSearch={handleTypeHeadSearch}
                                    options={options}
                                    disabled={addingPerson}
                                  />
                                
                                <p className="my-3">
                                  If the presenter doesn't have an account yet,
                                  you can create one for them.
                                </p>
                              </Modal.Body>
                              <Modal.Footer className="d-flex justify-content-center">
                              
                                <CreateNewUserModalButton
                                  //org_data={this.props.org_data}
                                  //user_data={this.props.user_data}
                                  custom_invitation_text={" to present at "+props.event_info.entity_name}
                                  //OnFinishCreateUser={this.createNewUser}
                                  //OnFinishCreateUser={this.getUsersFromApi}
                                  OnFinishCreateUser={(create_user_obj) => onAddPresentersChange([create_user_obj.insert_user])}
                                  //userCollisionError={this.state.userCollisionError}
                                  button_text={`Create a New Presenter PechaKucha.com Account`}
                                />          
                              
                                {/*
                                <Button
                                  onClick={onClickToggleAddUser}
                                  variant="pkprimary"
                                  disabled={addingPerson}>
                                  Create New Presenter
                                </Button>
                                */}
                              </Modal.Footer>
                            </Modal>
                          </td>
                          <td
                            className="border-none"
                            style={{ width: '45%' }}></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          {/* LEVIS INSERT ENDS HERE */}
        </Col>
        {/* <Col lg={12}>
          <hr />
        </Col> */}
        <Col lg={12}>
          {/* <Row>
            <Col lg={6}>
              <div className="eventSelect typeHead">
                <h5>Add Presenters</h5>
                <AsyncTypeahead
                  id="PresenterTypeAhead"
                  labelKey={(option) =>
                    `${option.entity_name} - ${option.friendly_url}`
                  }
                  isLoading={isAddPresenters}
                  filterBy={['typed_query', 'entity_name', 'friendly_url']}
                  placeholder="Add Presenters"
                  ref={presenter_typeahead_ref}
                  minLength={3}
                  onChange={onAddPresentersChange}
                  onSearch={handleTypeHeadSearch}
                  options={options}
                />
              </div>
              <p className="presenters">
                If the presenter doesn't have an account yet, you can create one
                for them.
              </p>
            </Col>
          </Row> */}
          
          {/*
          <div className="add-newVenue venueAlign">
            <div
              style={{
                display: successFormData === 0 ? 'none' : null
              }}
              className="Invalid-section">
              <p className="venueSuccessMsg">{`New Presenter Account Created Successfully`}</p>
            </div>
            {showComponent ? (
              <CreatePresenter
                getNewPresenterData={onGetNewPresenterData}
                autoClose={onClickToggleAddUser}
                city_Data={city_Data}
                createPresenter="Create Presenter"
                fisrtNameLabel="First Name"
                lastNameLabel="Last Name"
                friendlyLabel="Friendly Url"
                emailAddressLabel="email address"
                presenterCountry="Country"
                presenterCity="City"
                occupationLabel="Occupation"
                employerLabel="Employer"
                websiteLabel="Website"
                descriptionLabel="About"
                avatar={avatar}
                avatar_image_url={avatar_image_url}
                imagePreviewUrl={imagePreviewUrl}
                onChangeImage={onChangeImage}
                imgLoader={imgLoader}
                countryCityFilter={countryCityFilter}
                cityArr={cityArr}
                city={city}
                country={country}
                countryArr={countryArr}
                onClickFromRmUser={onClickToggleAddUser}
                createVenueLoader={createVenueLoader}
                createPresenterLoader={createPresenterLoader}
                userCollisionError={userCollisionError}
              />
            ) : null}
          </div>
          */}
        </Col>
      </Row>
      <div className="form-group btn-venueposition">

          <React.Fragment>
            <Button
              style={{ marginRight: '5px' }}
              size="sm"
              variant="secondary"
              onClick={prevScreen}>
              Previous
            </Button>
            <Button size="sm" variant="secondary" onClick={finalCreateEvent}>
              Finish
            </Button>
          </React.Fragment>

      </div>
    </div>
  );
}
export default withRouter(Presenters);
